import styled from "@emotion/styled";
import React from "react";
import { CustomThemeType } from "../../../context/Providers";

const LandingPageSectionWrapper = styled.div<{theme?: CustomThemeType}>`
    background-color: ${p => p.theme.background};
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    font-family: "Inter";
    &:nth-child(2) {
        /* background-color: color-mix(in hsl, ${p => p.theme.background}, ${p => p.theme.brand} 50%); */
        background-color: color-mix(in hsl, ${p => p.theme.background}, ${p => p.theme.brand} 5%);
    }
`;

export const LandingPageRow = styled.div<{
    height: string;
}>`
    height: ${p => p.height};
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
`;


interface LandingPageSectionProps {
    children: any;
}
 
const LandingPageSection: React.FC<LandingPageSectionProps> = ({ children }) => {
    return (<LandingPageSectionWrapper className="landing-page-section-wrapper">
        {children}
    </LandingPageSectionWrapper>);
}
 
export default LandingPageSection;
